var map = {
	"./blanched_broccoli.png": 5700,
	"./braised_pork_belly.png": 3051,
	"./braised_pork_ribs.png": 1101,
	"./braised_tofu_scallions.png": 8927,
	"./broccoli_fish_black_bean.png": 3650,
	"./broccoli_shiitake_mushrooms.png": 9507,
	"./broccoli_shrimp.png": 9200,
	"./century_egg_eggplant_chili.png": 5768,
	"./dry_fried_green_beans.png": 3301,
	"./fish_flavored_pork.png": 7358,
	"./fried_chicken_cutlet.png": 5647,
	"./home_style_cauliflower.png": 2830,
	"./lemon_shredded_chicken.png": 2476,
	"./malaysian_lemon_chicken.png": 4500,
	"./mapo_tofu.png": 705,
	"./minced_meat_fried_tofu.png": 7289,
	"./oat_crusted_chicken.png": 5974,
	"./salted_egg_shrimp.png": 6900,
	"./shrimp_three_vegetables.png": 3362,
	"./sichuan-style_meat_sauce.png": 2814,
	"./sour_cabbage_fish.png": 7973,
	"./spicy_chicken_wings.png": 2546,
	"./spicy_chicken_wings_2.png": 3581,
	"./spicy_king_oyster_mushroom.png": 4809,
	"./spicy_lotus_root.png": 9740,
	"./spicy_oyster_mushroom.png": 8255,
	"./spicy_pork_ribs.png": 281,
	"./spicy_squid_rings.png": 3900,
	"./stir_fried_chicken_breast.png": 308,
	"./stuffed_bell_peppers.png": 2500,
	"./tofu_dried_shrimp_scallions.png": 9127,
	"./tomato_egg_stir_fry.png": 3618,
	"./twice_cooked_pork.png": 8792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3733;